import { s as script$1 } from './Tag-0i8ndmgD.js';
import { openBlock, createElementBlock, normalizeClass, renderSlot } from 'vue';
import { a as registerComponent } from './plugins-C7548x21.js';
import './Icon-fJqkx1gN.js';
import './config-nHWiBviw.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';

var script = {
    name: 'BTaglist',
    props: {
        attached: Boolean
    }
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["tags", { 'has-addons': $props.attached }])
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}

script.render = render;
script.__file = "src/components/tag/Taglist.vue";

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script$1);
    registerComponent(Vue, script);
  }
};

export { script$1 as BTag, script as BTaglist, Plugin as default };
